/*
 * @Description: 房源维护列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-07-04 11:51:33
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import {Button, message, Divider, Popconfirm, Upload, Modal, Input, Menu, Dropdown, Icon} from 'antd';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {postFrom, config, transterQuery, post} from '../../axios';
import {
    dicHouseStatus,
    downloadTagsMap,
    repairRadioValueIsMap,
    repairReportStatusIsMap,
    syncStatusIsMap
} from '../../axios/dictionaries';
import {formatTime, handleExportParams, isPlatform} from '../../utils';
import JrApiLog from "../Other/JrApiLog";
import DeviceDetail from "./deviceDetail";
import RepairReportState from "./RepairReportState";

import {
    API_roomType_batchGeneration,
} from "../../axios/config";

export default class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',
                syncStatus:'',
                status: '',
                checkDeviceId: '',
                houseId: '',
                pageSize: 10,
            },

            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }

        let loginData = Cookies.get('loginData');
        if (loginData) { //校验登录是否失效
            loginData = JSON.parse(loginData);
            if (loginData.merchantId) {  //为商户人员添加商户id
                this.merchantId = loginData.merchantId || 0;
            }
        }
    }

    componentDidMount() {
        this.setLocationSearchToParam().then(()=> {
            this.handleSearch();
        })
    }

    setLocationSearchToParam = () => {
        return new Promise(resolve => {
            const { state } = this.props.location
            if(state && state.checkDeviceId) {
                this.setState(_state => {
                    _state.params.checkDeviceId = state.checkDeviceId
                    return _state
                },resolve)
            }else if(state && state.houseId) {
                this.setState(_state => {
                    _state.params.houseId = state.houseId
                    return _state
                },resolve)
            }else {
                resolve()
            }
        })
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_roomType_findDeviceRepairReportPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleJrApiLogInfo(tableName,id) {
        //console.log(this);
        this.jrApiLogRef.open(tableName,id);
    }

    // handleEdit = (id) => { //编辑
    //     this.setState({ showAddModal: true });
    //     this.maintainAddRef.loadPack({ id });
    //     this.maintainAddRef.loadBuildingList();
    // }

    handleDelete = (id) => { //删除
       //  this.setState({ showDeleteModal: true });
       // this.RepairReportStateRef.loadPackage(id);
        this.RepairReportStateRef.open(id).then(res => {
            this.handleSearch()
        })
    }

    handleRemove = (id) => { //删除
        this.setState({ tableLoading: false });
        let data = { houseId: id };
        postFrom({ url: config.API_house_deleteHouse, data }).then(res => {
            this.setState({ tableLoading: false });
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '删除失败');
            this.setState({ tableLoading: false });
        });
    }
    handleEdit = (id) => {
        postFrom({ url: config.API_roomType_downloadImages+"?checkRoomDeviceId="+id }).then(res => {
            const ele = document.createElement('a'); //新建一个a标签
            ele.setAttribute('href', res);
            ele.setAttribute('target', "blank");
            document.body.appendChild(ele);
            ele.click();
            ele.remove();
        }).catch(err => {
            message.error(err.message || '下载二维码失败');
            this.setState({ tableLoading: false });
        });
    }

    handleInfo = (id) => {
        this.DeviceDetailRef.open(id).then(res => {
            this.handleSearch()
        })
    }

    postAsyncBatchCheck(id) {
        return post({ url: API_roomType_batchGeneration  +'?id=' + id }).then(() => {
            message.success('批量生成中，请10到20分钟后查看')
        }).catch(e => {
            message.error(e.message)
        })
    }

    handleAsyncBatchCheck() {
        this.postAsyncBatchCheck().then(() =>{
            this.handleSearch()
        })
    }


    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
        } = this.state;
        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="z-3-2" type="primary" icon="export" href={`${config.API_report_deviceRepairReportExprotDateExcel}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出报修记录
                        </AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleInfo: this.handleInfo,handleDelete: this.handleDelete,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                    scroll={{x: 1500}}
                />
                <JrApiLog ref={ref=>{
                    this.jrApiLogRef=ref;
                }}/>
                <DeviceDetail wrappedComponentRef={ ref=> this.DeviceDetailRef = ref } />
                <RepairReportState wrappedComponentRef={ ref=> this.RepairReportStateRef = ref } />
            </PageWrap>
        )
    }


}

const searchData = () => {
    let data =  [
    {
        tagName: 'Select',
        formConfig: { name: 'state' },
        attribute: { placeholder: '请选择报修状态', style: { width: '140px' } },
        optionData: [{ title: '全部', value: '' }].concat(repairReportStatusIsMap), //.concat(dicHouseStatus)
        notResult: '',
    },
    {
        tagName: 'Select',
        formConfig: { name: 'radioValue' },
        attribute: { placeholder: '请选择服务类型', style: { width: '140px' } },
        optionData: [{ title: '全部', value: '' }].concat(repairRadioValueIsMap), //.concat(dicHouseStatus)
        notResult: '',
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'categoryName' },
        attribute: { placeholder: '输入户型品类', style: { width: '160px' } },
        title: `在户型品类模糊查询`
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'projectName' },
        attribute: { placeholder: '输入项目名称', style: { width: '160px' } },
        title: `在项目名称模糊查询`
    }, {
        tagName: 'InputTip',
        formConfig: { name: 'buildingName' },
        attribute: { placeholder: '输入小区/楼栋', style: { width: '160px' } },
        title: `在小区/楼栋名称模糊查询`
    }, {
        tagName: 'InputTip',
        formConfig: { name: 'houseName' },
        attribute: { placeholder: '输入房号', style: { width: '160px' } },
        title: `在房号模糊查询`
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'userName' },
        attribute: { placeholder: '输入报修人姓名', style: { width: '160px' } },
        title: `在报修人姓名模糊查询`
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'customerPhone' },
        attribute: { placeholder: '输入报修人手机', style: { width: '160px' } },
        title: `在报修人手机模糊查询`
    }
]

   /* data = data.filter(e => {
        if(isPlatform()){
            return true;
        }
        if (e.formConfig.name === 'syncStatus') {
            return false;
        }
        return true;
    });*/

    return data;
};

const columns = ({ handleEdit, handleInfo,handleDelete,handleJrApiLogInfo }) => [
    {
        title: '项目名称',
        dataIndex: 'projectName',
        fixed: 'left'
    },
    {
        title: '小区/楼栋',
        dataIndex: 'buildingName'
    },
    {
        title: '门店名称',
        dataIndex: 'ccbProjectName'
    },
    {
        title: '房源编号',
        dataIndex: 'houseNo'
    },
    {
        title: '房号',
        dataIndex: 'houseName'
        , width:80 ,
    },
    {
        title: '户型品类',
        dataIndex: 'categoryName'
        , width:80 ,
    },
    {
        title: '设备品类',
        dataIndex: 'deviceCategory'
        , width:80 ,
    },
    {
        title: '设备型号',
        dataIndex: 'deviceModel'
    },
    {
        title: '服务类型',
        dataIndex: 'radioValue'
    },
    {
        title: '报修人姓名',
        dataIndex: 'userName'
    },
    {
        title: '报修人手机',
        dataIndex: 'phone'
    },
    {
        title: '报修时间',
        dataIndex: 'createTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '报修状态',
        dataIndex: 'state',
        render(text) {
            if (!text) return '-'
            return text==1? '待处理': (text==2? '派单中': (text==3 ?'维修中' :'已完成'))
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200,
        fixed: 'right',
        render(text, record, index) {
            const moreMenu = (<Menu>
                <AuthButton authkey="e-1-4"><div className="ant-dropdown-menu-item" onClick={() => { handleDelete(record.id) }}>派单中</div></AuthButton>
                <AuthButton authkey="e-1-4"><div className="ant-dropdown-menu-item" onClick={() => { handleDelete(record.id) }}>维修中</div></AuthButton>
                <AuthButton authkey="e-1-4"><div className="ant-dropdown-menu-item" onClick={() => { handleDelete(record.id) }}>已完成</div></AuthButton>
            </Menu>)

           return <span><AuthButton authkey="z-3-3">
                    <a  onClick={() => { handleInfo(record.id) }}>报修详情</a >
                </AuthButton>
               {/*<AuthButton authkey="z-3-5">*/}
               {/*      <Divider type="vertical" />*/}
               {/*     <a  onClick={() => { handleDelete(record.id) }}>状态变更</a >*/}
               {/* </AuthButton>*/}
            </span>
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/DeviceRepairReport/RepairReport.js